import Vue from 'vue'
import TDesign from 'tdesign-vue'
// import GyFormSdk from '@tencent/gy-form-sdk'
import VueCropper from 'vue-cropper';
// import Util from '@/common/util';
// import { queryCorpInfo, Login } from '@/common/request';
// import { AppSuiteID } from '@/common/config';
import 'tdesign-vue/es/style/index.css';
// import '@tencent/gy-form-sdk/dist/gy-form-sdk.css'
import '@/styles/reset.less';
import '@/styles/base.css';
import '@/styles/common.less';
import "@/styles/tdesign.less";
import App from './App.vue'
import Router from './router';
// import filters from "@/common/filters";
Vue.use(TDesign);
// Vue.use(GyFormSdk)
Vue.use(VueCropper);

// 🔧 全局错误处理 - 捕获组件库内部错误
Vue.config.errorHandler = function (err, vm, info) {
  // 捕获 IntersectionObserver 相关错误
  if (err.message && err.message.includes('unobserve is not a function')) {
    console.warn('TDesign 组件 IntersectionObserver 错误已被捕获:', err.message);
    return; // 静默处理，不显示给用户
  }

  // 其他错误正常处理
  console.error('Vue 全局错误:', err, vm, info);
};

// 🔧 全局警告处理 - 捕获 destroyed hook 错误
const originalWarn = console.warn;
console.warn = function (...args) {
  const message = args.join(' ');
  if (message.includes('Error in destroyed hook') && message.includes('unobserve is not a function')) {
    console.debug('TDesign 组件销毁警告已被捕获:', message);
    return; // 静默处理
  }
  originalWarn.apply(console, args);
};

function waitGYL(timeout = 15000) {
  return new Promise((resolve, reject) => {
    if (window.GYL && window.GYL.GYLInit) {
      resolve(window.GYL);
      return;
    }
    const start = Date.now();
    const timer = setInterval(() => {
      if (window.GYL && window.GYL.GYLInit) {
        clearInterval(timer);
        resolve(window.GYL);
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        reject(new Error('登录 SDK 加载超时'));
      }
    }, 50);
  });
}

function initLoginSdk() {
  waitGYL()
    .then(GYL => {
      GYL.GYLInit({
        appid: 'b2b',
        platformType: 2,
        onRefresh: () => {
          window.location.reload();
        },
        onReLogin: () => {
          GYL.GYLogout().then(() => {
            sessionStorage.removeItem('nolocate');
            window.location.hash = '#/login';
            window.location.reload();
          });
        },
      });
    })
    .catch(err => {
      console.warn('[GYLInit]', err && err.message);
    });
}

function renderPage() {
  // 渲染页面
  new Vue({
    render: h => h(App),
    router: Router,
    beforeCreate() {
      Vue.prototype.$bus = this;
      // Vue.prototype.$util = Util;
    },
  }).$mount('#ent-app')
}

initLoginSdk();
renderPage();